var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PaymentComponentSettings } from "./payment.model";
import { PaymentMethodTypes } from "../../enums/order-source-type";
import { PaymentProcessor } from "./payment-processor.enum";
var ACHComponentSettings = /** @class */ (function (_super) {
    __extends(ACHComponentSettings, _super);
    function ACHComponentSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.paymentMethodTypes = PaymentMethodTypes;
        _this.processorTypes = PaymentProcessor;
        _this.isAddNewCard = false;
        return _this;
    }
    return ACHComponentSettings;
}(PaymentComponentSettings));
export { ACHComponentSettings };



// WEBPACK FOOTER //
// ./src/app/customerservice/models/payments/payment-ach.model.ts.pre-build-optimizer.js